module.exports = __webpack_public_path__ + "static/media/mask.c3923a70.png";